export default __webpack_public_path__ + "device_doorbell_pro.94d769fd.png";